import { UNIFIED_ROUTE_REQUEST_DEMO } from '~/constants/routes/unified';
import { SCHOOLS_US_DEMO_FORM_URL } from '~/constants/schools';

interface SchoolsDemoLink {
  to: string;
  target?: '_blank';
  rel?: string;
}

/**
 * The link attributes a schools landing "request a demo" CTA carries, which differ by market: the
 * US opens the off-site HubSpot form in a new tab, AU navigates to the in-app enquiry page in
 * place. Shared so the five CTAs across the four landing views cannot drift apart.
 *
 * `rel` stays `noopener` rather than also `noreferrer` so HubSpot still receives the referrer it
 * attributes the enquiry to.
 */
export const useSchoolsDemoLink = (): SchoolsDemoLink => {
  const { isUsa } = useClusterCountryConfig();

  if (!isUsa) {
    return { to: UNIFIED_ROUTE_REQUEST_DEMO };
  }

  return { to: SCHOOLS_US_DEMO_FORM_URL, target: '_blank', rel: 'noopener' };
};
